import React from "react";
import "./CoinPackCard.css";
import coinImg from "../../assets/images/coiin.png";

const CoinIcon = () => {
  return (
    <div className="coinn-pack-icon-wrapper">
      <div className="coinn-pack-icon">
        <img src={coinImg} alt="" />
      </div>
    </div>
  );
};

function formatPrice(value) {
  return `Rs ${Number(value || 0)}`;
}

const CoinPackItem = ({ pack, onBuy, isBuying }) => {
  return (
    <div className="coinn-pack-card">
      <div className="coinn-pack-card-top">
        <CoinIcon />

        <div className="coinn-pack-info">
          <h3>{pack.coins}</h3>
          <span>Coins</span>
        </div>
      </div>

      <div className="coinn-pack-divider" />

      <div className="coinn-pack-price-row">
        <div className="coinn-pack-prices">
          <span className="coinn-pack-current-price">{formatPrice(pack.discountedPrice)}</span>

          <span className="coinn-pack-old-price">{formatPrice(pack.amount)}</span>
        </div>

        <span className="coinn-pack-discount">{pack.discountPercent}% OFF</span>
      </div>

      <button type="button" className="coinn-pack-buy-btn" onClick={() => onBuy?.(pack)} disabled={isBuying}>
        {isBuying ? 'Loading...' : 'Buy Now'}
      </button>
    </div>
  );
};

const CoinPackCardShimmer = () => {
  return (
    <div className="coinn-pack-card" aria-hidden="true">
      <div className="coinn-pack-card-top">
        <span
          className="dashboard-skeleton dashboard-skeleton--button"
          style={{ width: 58, height: 58, borderRadius: "50%" }}
        />
        <div className="coinn-pack-info">
          <span
            className="dashboard-skeleton dashboard-skeleton--line"
            style={{ width: 70, height: 22 }}
          />
          <span
            className="dashboard-skeleton dashboard-skeleton--line"
            style={{ width: 46, marginTop: 10 }}
          />
        </div>
      </div>
      <div className="coinn-pack-divider" />
      <div className="coinn-pack-price-row">
        <div className="coinn-pack-prices">
          <span
            className="dashboard-skeleton dashboard-skeleton--line"
            style={{ width: 74, height: 20 }}
          />
          <span
            className="dashboard-skeleton dashboard-skeleton--line"
            style={{ width: 62, marginTop: 8 }}
          />
        </div>
        <span
          className="dashboard-skeleton dashboard-skeleton--line"
          style={{ width: 70, height: 18 }}
        />
      </div>
      <span
        className="dashboard-skeleton dashboard-skeleton--button"
        style={{
          width: "100%",
          height: 46,
          borderRadius: 999,
          display: "block",
          marginTop: 18,
        }}
      />
    </div>
  );
};

const CoinPacks = ({ packs = [], isLoading = false, onHistoryClick, onBuy, buyingPackId }) => {
  const displayPacks = Array.isArray(packs) ? packs : [];

  return (
    <div className="coinn-packs-container">
      <div className="coinn-packs-header">
        <div>
          <h2>Choose your pack</h2>

          <p>Simple pricing with clear savings on every plan.</p>
        </div>

        <button type="button" className="coinn-history-btn" onClick={onHistoryClick}>
          <span className="coinn-history-icon">
            <i className="fa-solid fa-clock-rotate-left"></i>
          </span>
          History
          <span className="coinn-history-arrow">
            <i className="fa-solid fa-chevron-right"></i>
          </span>
        </button>
      </div>

      <div className="coinn-packs-grid">
        {isLoading
          ? Array.from({ length: 4 }).map((_, index) => <CoinPackCardShimmer key={index} />)
          : displayPacks.map((pack) => <CoinPackItem key={pack.id || pack.coins} pack={pack} onBuy={onBuy} isBuying={buyingPackId != null} />)}
      </div>
    </div>
  );
};

export default CoinPacks;
